export default "__VITE_ASSET__lH$aObmf__"